import { Grid, Typography } from "@mui/material";
import { isValid } from "date-fns";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import {
  DesktopDatePickerLight,
  TextFieldLight,
} from "../../../../common/components/styled/styled";

type Props = {
  disableEdit: boolean;
  salaryLimit: string;
  periodStartDate: Date | null;
  periodStartDateIsRequired: boolean | null;
  handleSalaryLimitChange: (value: string) => void;
  handlePeriodStartDateChange: (value: Date | null) => void;
};

const Input = ({ ...props }) => (
  <TextFieldLight
    {...props}
    sx={{ width: "110px" }}
    name="salaryLimit"
    size="small"
    placeholder="€/h"
    inputProps={{
      style: {
        textAlign: "center",
      },
    }}
  />
);

const getIsValidDate = (value: Date | null, required: boolean): boolean => {
  if (required) {
    return value !== null && isValid(value);
  }
  return value === null || isValid(value);
};

export const SalaryLimit = ({
  disableEdit,
  salaryLimit,
  periodStartDate,
  periodStartDateIsRequired,
  handleSalaryLimitChange,
  handlePeriodStartDateChange,
}: Props) => {
  const { t } = useTranslation("order");
  return (
    <>
      <Grid container item xs={3} justifyContent="flex-end" alignItems="center">
        <Typography variant="secondary">{t("salaryLimitLabel")}</Typography>
      </Grid>
      <Grid item xs={9}>
        <NumericFormat
          disabled={disableEdit}
          value={salaryLimit}
          decimalSeparator=","
          valueIsNumericString
          onValueChange={(values) => handleSalaryLimitChange(values.value)}
          suffix=" €/h"
          customInput={Input}
          decimalScale={2}
        />
      </Grid>
      <Grid container item xs={3} justifyContent="flex-end">
        <Typography variant="secondary">{t("periodStartDate")}</Typography>
      </Grid>
      <Grid item xs={9}>
        {/* TODO FIXME check if date can be formatted with weekday */}
        <DesktopDatePickerLight
          format={"dd.MM.yyyy"}
          value={periodStartDate}
          disabled={disableEdit}
          disableOpenPicker={disableEdit}
          onChange={(value: any) => {
            handlePeriodStartDateChange(value);
          }}
          slotProps={{
            textField: {
              error: !getIsValidDate(
                periodStartDate,
                !!periodStartDateIsRequired,
              ),
              size: "small",
              name: "date",
              sx: { backgroundColor: "rgba(249, 249, 250, 0.6)" },
            },
          }}
        />
      </Grid>
    </>
  );
};
